import script from "./Comment.vue?vue&type=script&setup=true&lang=js"
export * from "./Comment.vue?vue&type=script&setup=true&lang=js"

import "./Comment.vue?vue&type=style&index=0&id=0ecdd207&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ecdd207"]])

export default __exports__